<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Privacy Policy</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Privacy Policy</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="privacy-area pt-100">
  <div class="container">
    <h1>Privacy Policy</h1>

    <h5>Privacy Policy</h5>
    <p>
      Magnus Recruitment Solutions is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, 
      and safeguard your personal information in accordance with the Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs).
    </p>

    <h5>1. Information We Collect</h5>
    <p>We may collect your name, contact details, resume, education history, and IP address.</p>

    <h5>2. How We Collect Information</h5>
    <p>Via online forms, email, phone, cookies, and analytics tools.</p>

    <h5>3. Purpose of Collection</h5>
    <p>To match candidates with jobs, communicate with stakeholders, and improve services.</p>

    <h5>4. Disclosure of Information</h5>
    <p>To employers, service providers, and legal authorities where required.</p>

    <h5>5. Data Security</h5>
    <p>We use standard industry practices to protect your data.</p>

    <h5>6. Access and Correction</h5>
    <p>You may contact us to request access to or correction of your data.</p>

    <h5>7. Cookies</h5>
    <p>Cookies may be used to enhance site experience. You can disable them via browser settings.</p>

    <h5>8. Changes to Privacy Policy</h5>
    <p>We may update this policy and post changes here with a revised date.</p>

    <h5>9. Contact Us</h5>
    <p>Email: administrator&#64;magnusrecruitment.com.au</p>
    <p>Website: <a href="https://magnusrecruitment.com.au" target="_blank">https://magnusrecruitment.com.au</a></p>
  </div>
</section>